import { render, staticRenderFns } from "./AdicionarSignatarios.vue?vue&type=template&id=6277c7b6&"
import script from "./AdicionarSignatarios.vue?vue&type=script&lang=js&"
export * from "./AdicionarSignatarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports